import { IdSchema } from '@batiflow/contracts';
import { z } from 'zod';

/**
 * Search params of the viewer route: the version being viewed (the current one when absent) and,
 * to compare two versions, the other one. An
 * invalid value is dropped, so a mangled link still opens the document.
 */
export const ViewerSearchSchema = z.object({
  versionId: IdSchema.optional().catch(undefined),
  /** A second version: both are compared (CdC GED-03) instead of one being shown. */
  compare: IdSchema.optional().catch(undefined),
  /** The page to open a PDF on (a link from an observation). */
  page: z.coerce.number().int().min(1).max(100_000).optional().catch(undefined),
});
export type ViewerSearch = z.infer<typeof ViewerSearchSchema>;
